
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import BestsellerCard from '~/components/BestsellerCard.vue';

export default {
    name: 'HomeBestsellers',
    components: {Swiper, SwiperSlide, BestsellerCard},
    props: {
        products: {type: Array, required: true},
    },
    data() {
        return {
            atBeginning: true,
            atEnd: false,
            swiperOptions: {
                preloadImages: false,
                slidesPerView: 'auto',
                // Swiper owns slide spacing; CSS margins would be counted twice in auto mode.
                spaceBetween: 5,
                watchOverflow: true,
                keyboard: {enabled: true, onlyInViewport: true},
                scrollbar: {
                    el: '.home-bestsellers__scrollbar',
                    draggable: true,
                    dragSize: 56,
                    hide: false,
                },
                breakpoints: {
                    1024: {slidesPerView: 5, spaceBetween: 5, scrollbar: {dragSize: 100}},
                },
                on: {
                    breakpoint(params) {
                        // Swiper 5 leaves desktop inline widths on slides when
                        // returning to auto sizing; restore the mobile CSS width.
                        if (params.slidesPerView === 'auto' && this.slides) {
                            this.slides.each((index, slide) => {slide.style.width = '';});
                        }
                    },
                },
            },
        };
    },
    computed: {
        cards() {
            return this.products.filter(card => Array.isArray(card.variants) && card.variants.length);
        },
    },
    watch: {
        cards() {
            this.$nextTick(() => {
                const swiper = this.$refs.bestsellersSwiper && this.$refs.bestsellersSwiper.$swiper;
                if (!swiper || swiper.destroyed) return;
                // Only data changes need a layout pass. Updating arrow state must not
                // make vue-awesome-swiper recalculate every slide during a gesture.
                swiper.update();
                this.updateNavigation();
            });
        },
    },
    methods: {
        updateNavigation() {
            this.$nextTick(() => {
                const swiper = this.$refs.bestsellersSwiper && this.$refs.bestsellersSwiper.$swiper;
                if (swiper && !swiper.destroyed) {
                    this.atBeginning = swiper.isBeginning || swiper.isLocked;
                    this.atEnd = swiper.isEnd || swiper.isLocked;
                }
            });
        },
        slidePrev() {
            const swiper = this.$refs.bestsellersSwiper && this.$refs.bestsellersSwiper.$swiper;
            if (swiper) swiper.slidePrev();
        },
        slideNext() {
            const swiper = this.$refs.bestsellersSwiper && this.$refs.bestsellersSwiper.$swiper;
            if (swiper) swiper.slideNext();
        },
    },
}
